import React, {
    FC, useCallback, useEffect, useRef,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import {
    apiGetActions,
    partsSelectActions,
} from '@app/react/action';
import { showOrderPartsHelpAction } from '@app/react/action/showOrderPartsHelp';
import { IinitState } from '@app/react/reducer';
import type { AppState } from '@app/react/reducer';
import { OrderCommon2SelectComponent } from '@component/OrderCommon2SelectComponent';
import { OrderPartsHelpArrowhead } from '@component/OrderPartsHelp';
import { OnSelectProductHandler } from '@app/react/uikit/ProductThumbnail';
import { hideEcHeaderNavi } from '@root/app/react/common/Function';
import { useOrderPathParams } from '@app/react/contexts/useOrderPathParams';
import { GetResponseOrderParts } from '@app/react/const/type';
import { useMediaDesktop, useMediaMobile } from '@app/react/common/useMedia';
import { useWindowScrollPosition } from '@app/react/hooks/useWindowScrollPosition';
import { selectOrderPartsHelp } from './selectors';

export const OrderYajiriSelectContainer: FC<{ waitFetch?: boolean }> = ({ waitFetch = false }) => {
    const dispatch = useDispatch();
    const { arrowType, orderType } = useOrderPathParams();
    const isDesktop: boolean = useMediaDesktop();
    const isMobile: boolean = useMediaMobile();
    const scrollObj = useRef(null);
    useWindowScrollPosition('scroll_yajiri', true, scrollObj);

    const customizeData = useSelector<AppState, IinitState>(
        (state) => state.customize,
    );
    const ProductList = useSelector<AppState, GetResponseOrderParts | null>(
        (state) => state.APIData.arrowhead,
    );
    const partsData = ProductList?.partsData || [];

    const openHelpParts = useSelector(selectOrderPartsHelp);
    const isOpenHelp = openHelpParts === 'arrowhead';

    const onSelectProduct: OnSelectProductHandler = useCallback(
        (__, product) => {
            dispatch(partsSelectActions.arrowhead.started({ param: product }));
        },
        [dispatch],
    );

    const openHelp = useCallback(() => {
        dispatch(showOrderPartsHelpAction({ partsName: 'arrowhead' }));
    }, [dispatch]);

    const closeHelp = useCallback(() => {
        dispatch(showOrderPartsHelpAction({ partsName: null }));
    }, [dispatch]);

    useEffect(() => {
        hideEcHeaderNavi(isDesktop, isMobile, dispatch);
    }, [isDesktop, isMobile, dispatch]);

    useEffect(() => {
        if (waitFetch) {
            console.log('initializing, waiting fetch');
            return;
        }
        dispatch(
            apiGetActions.arrowhead.started({
                arrowType,
                orderType,
                selectItems: customizeData,
            }),
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, arrowType, orderType, waitFetch]);

    return (
        <>
            <OrderCommon2SelectComponent
                rootRef={scrollObj}
                classes="order-arrowhead-select"
                partsNameProps="矢尻"
                customizeData={customizeData}
                onSelectProduct={onSelectProduct}
                partsData={partsData}
                kind="arrowhead"
                showHelpBtn
                onHelpClick={openHelp}
                LameHtml={(
                    <p className={classNames('section-header', { hidden: isDesktop })}>
                        矢尻
                    </p>
                )}
            />
            <OrderPartsHelpArrowhead
                isOpen={isOpenHelp}
                handleOpen={openHelp}
                handleClose={closeHelp}
            />
        </>
    );
};
